import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { toast } from "sonner";
import { Trash } from "@phosphor-icons/react";

export default function InquiriesTab() {
    const [items, setItems] = useState([]);

    const load = () =>
        api.get("/admin/sponsor-inquiries")
            .then((r) => setItems(r.data))
            .catch(() => toast.error("Gagal memuat data"));

    useEffect(() => {
        load();
    }, []);

    const remove = async (item) => {
        if (!window.confirm(`Hapus pengajuan dari "${item.name}"?`)) return;
        try {
            await api.delete(`/admin/sponsor-inquiries/${item.id}`);
            toast.success("Data dihapus");
            load();
        } catch {
            toast.error("Gagal menghapus");
        }
    };

    return (
        <div data-testid="inquiries-tab">
            <h2 className="font-display uppercase text-2xl text-neutral-900 mb-6">Pengajuan Sponsor</h2>
            <div className="border border-racing-line overflow-x-auto">
                <table className="w-full text-sm">
                    <thead>
                        <tr className="border-b border-racing-line bg-racing-surface">
                            {["Nama / Brand", "Kontak", "Paket", "Pesan", "Tanggal"].map((h) => (
                                <th key={h} className="text-left px-4 py-3 text-[10px] uppercase tracking-[0.2em] text-racing-muted font-medium">
                                    {h}
                                </th>
                            ))}
                            <th className="px-4 py-3" />
                        </tr>
                    </thead>
                    <tbody>
                        {items.length === 0 && (
                            <tr>
                                <td colSpan={6} className="px-4 py-8 text-center text-racing-muted" data-testid="inquiries-empty">
                                    Belum ada pengajuan sponsor.
                                </td>
                            </tr>
                        )}
                        {items.map((item, i) => (
                            <tr key={item.id} className="border-b border-racing-line last:border-0 hover:bg-black/[0.03]" data-testid={`inquiries-row-${i}`}>
                                <td className="px-4 py-3 text-neutral-900 font-medium">{item.name}</td>
                                <td className="px-4 py-3 text-neutral-800">{item.contact}</td>
                                <td className="px-4 py-3 text-neutral-800 capitalize">{item.package}</td>
                                <td className="px-4 py-3 text-neutral-800 max-w-[280px] truncate">{item.message || "—"}</td>
                                <td className="px-4 py-3 text-racing-muted text-xs">{(item.created_at || "").slice(0, 10)}</td>
                                <td className="px-4 py-3">
                                    <button
                                        onClick={() => remove(item)}
                                        data-testid={`inquiries-delete-${i}`}
                                        className="p-2 border border-racing-line text-racing-muted hover:text-racing-red hover:border-racing-red transition-colors"
                                        aria-label="Hapus"
                                    >
                                        <Trash size={16} />
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}
